<template>
  <Splitpanes class="default-theme">
    <Pane size="50" style="background: none">
      <slot name="canvas" v-bind="slotDataCanvas"></slot>
    </Pane>
    <Pane style="background: none; position: relative">
      <slot name="aside" v-bind="slotDataContent"></slot>
    </Pane>
    <Pane
      v-if="tagMode === 'showList'"
      style="background: none; position: relative; overflow: auto"
    >
      <slot name="metadata" v-bind="slotMetadataContent"></slot>
    </Pane>
  </Splitpanes>
</template>

<style>
.splitpanes__splitter:hover {
  background-color: rgba(127, 0, 255, 0.25) !important;
}
</style>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("browser");

export default {
  components: { Splitpanes, Pane },
  props: {
    content: {
      type: [Array, Object],
      required: true,
    },
  },
  watch: {
    selectedElements(elements) {
      for (var i = 0; i < this.content.length; i++) {
        this.content[i].children.map((element) => {
          if (element) {
            this.elementStates[i][element.id] = {
              ...this.elementStates[i][element.id],
              isSelected: elements.includes(element.id),
              isFocused: elements.includes(element.id),
              eventSource: this.eventSource,
            };
            element = {
              ...element,
              ...this.elementStates[i][element.id],
            };
          }
        });
      }
    },
  },
  data() {
    // FIXME: do highlighting, result snippet parsine here??
    return {
      elementStates: this.makeElementStates(),
      isReady: false,
    };
  },
  computed: {
    ...mapState(["selectedElements", "eventSource", "tagMode"]),
    slotDataCanvas() {
      console.log("slotDataCanvas");
      console.log(this.statefulElements);
       var flattened = [];
        for (var region in this.statefulElements) {
          var element = this.statefulElements[region];
          var filtered = element.children.filter(function(el) {
            return el != null;
          });
          flattened.push(...filtered);
        }
      
      return {
        handleElementClick: this.handleCanvasClick,
        elements: flattened,
      };
    },

    slotDataContent() {
      return {
        handleElementClick: this.handleContentClick,
        elements: this.statefulElements,
      };
    },
    slotMetadataContent() {
      return {
        handleElementClick: this.handleContentClick,
        elements: this.statefulElements,
      };
    },
    statefulElements() {
      console.log("statefulElements");
      for (var i = 0; i < this.content.length; i++) {
        this.content[i].children = this.content[i].children.map((element) => {
          if (element) {
            element = {
              ...element,
              ...this.elementStates[i][element.id],
            };
           return element
          }
        });
      }
      console.log(this.content);
      return this.content;
    },
  },
  beforeDestroy() {
    this.clearSelectedElements();
  },
  methods: {
    ...mapActions([
      "toggleSelectedElement",
      "clearSelectedElements",
      "setEventSource",
    ]),
    handleCanvasClick(id) {
      this.setEventSource("canvas");
      this.toggleSelectedElement(id);
    },
    makeElementStates() {
      var temp = [];
      this.content.forEach(function(region) {
        var filtered = region.children.filter(function(el) {
          return el != null;
        });
        var obj = filtered.reduce(
          (obj, val) => ({
            ...obj,
            [val.id]: {
              isHighlighted: val.highlight,
              isSelected: false,
            },
          }),
          {}
        );
        temp.push(obj);
      });
      return temp;
    },
    handleContentClick(id) {
      this.setEventSource("content");
      this.toggleSelectedElement(id);
    },
  },
};
</script>
